import { render, staticRenderFns } from "./MovideskChat.vue?vue&type=template&id=21d2b0a7&scoped=true&"
import script from "./MovideskChat.vue?vue&type=script&lang=js&"
export * from "./MovideskChat.vue?vue&type=script&lang=js&"
import style0 from "./MovideskChat.vue?vue&type=style&index=0&id=21d2b0a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d2b0a7",
  null
  
)

export default component.exports